import { selectors } from 'publisher/reducers/optInReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useOptIn(selector) {
  return useSelector(state => selector(state.optIn), shallowEqual)
}
